module.exports = __webpack_public_path__ + "static/media/pol_bg_1.9e4637ac.jpg";